const passwordInputList = document.querySelectorAll('.wcl-form .data-input--password');

if (passwordInputList.length > 0) {
    passwordInputList.forEach(item => {
        const input = item.querySelector('input');
        const showButton = item.querySelector('.data-show-password-button');

        showButton.addEventListener('click', e => {
            e.preventDefault();

            if (input.type == 'password') {
                input.type = 'text';
                showButton.classList.add('hide')
            } else {
                input.type = 'password';
                showButton.classList.remove('hide')
            }
        });
    });
}